export default "__VITE_ASSET__BTG2s_oz__"